import {Component, Injectable, Injector, Input} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {provideSearchModel, SearchModel, SearchResult, SearchSortField} from "@fedeltapointofsale/data-client";
import {Observable, of} from "rxjs";
import {parseNumber} from "@progress/kendo-angular-intl";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Injectable()
export class YearCalendarQuarterSearchModel extends SearchModel<any> {

    private readonly maximum_days = 20 * 365;

    startDate: string;
    endDate: string;

    constructor(injector: Injector) {
        super(injector);
    }

    convertDate(date: string): Date {
        if (date) {
            const parts: string[] = date.split("-");
            return new Date(parseNumber(parts[0]), parseNumber(parts[1]) - 1, parseNumber(parts[2]));
        } else {
            return undefined;
        }
    }

    override searchRecords(filter: any, start: number, limit: number, sort: SearchSortField[]): Observable<SearchResult> {
        const currentDate: Date = this.endDate != undefined ? this.convertDate(this.endDate) : new Date();
        currentDate.setMonth(currentDate.getMonth() % 3);
        currentDate.setDate(1);

        let compareStartDay: Date = this.convertDate(this.startDate);
        if (!compareStartDay) {
            compareStartDay = new Date();
            compareStartDay.setDate(compareStartDay.getDate() - this.maximum_days);
        }
        compareStartDay.setMonth(compareStartDay.getMonth() % 3);
        compareStartDay.setDate(1);

        const data: any[] = [];
        while (currentDate >= compareStartDay && data.length <= limit) {
            const qtr: number = Math.floor(currentDate.getMonth() / 3) + 1;
            const formattedDate: string = "Q" + qtr + "/" + currentDate.getFullYear();
            const valueDate: string = currentDate.getFullYear() + "/Q" + qtr;
            if (!filter["label"] || formattedDate.indexOf(filter["label"]) !== -1) {
                data.push({"label": formattedDate, "value": valueDate});
            }
            currentDate.setMonth(currentDate.getMonth() - 3);
        }
        return of(new SearchResult(data, data.length, true));
    }
}

@Component({
    selector: "wbo-year-calendar-quarter-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(YearCalendarQuarterSearchModel),
        registerSearchControl(YearCalendarQuarterMultiSelectSearchControlComponent)
    ]
})
export class YearCalendarQuarterMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<YearCalendarQuarterSearchModel> {
    constructor(model: YearCalendarQuarterSearchModel, injector: Injector) {
        super(model, injector);
    }

    get startDate(): string {
        return this.model.startDate;
    }

    @Input()
    set startDate(value: string) {
        this.model.startDate = value;
    }

    get endDate(): string {
        return this.model.endDate;
    }

    @Input()
    set endDate(value: string) {
        this.model.endDate = value;
    }

    override getLabelForValue(value: any): string {
        return value.replace(/^(\d\d\d\d)\/(\d)$/, "$2/Q$1");
    }
}
